import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert, Grid } from "@mui/material";
import Layout from "./Layout";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const ForgotCredentials = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [submissionError, setSubmissionError] = useState("");
  const [submissionSuccess, setSubmissionSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionError("");
    setSubmissionSuccess("");

    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setSubmitting(true);
    try {
      // The backend now always responds with a generic "Pass" whether or
      // not the address is on file, so this screen can't be used to probe
      // for registered emails. Don't branch UI copy on the response body.
      await axios.post(`${baseURL}/licensing/email_license/`, {
        email_id: formData.email,
      });

      setSubmissionSuccess(
        "If an account is associated with that email, we've sent a one-time " +
          "code along with your username and license key. It expires in 10 minutes.",
      );
    } catch (error) {
      console.error(error);
      // Network/server errors only - never reveal account existence here.
      setSubmissionError("An unexpected error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <Typography variant="h5" gutterBottom>
        Forgot Credentials
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        {submissionError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submissionError}
          </Alert>
        )}

        {submissionSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {submissionSuccess}
          </Alert>
        )}

        <TextField
          name="email"
          label="Email Address"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          error={!!formErrors.email}
          helperText={formErrors.email}
        />

        <Button
          fullWidth
          variant="contained"
          type="submit"
          sx={{ mt: 2 }}
          disabled={submitting}
        >
          Send Reset Code
        </Button>

        {submissionSuccess && (
          <Button
            fullWidth
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={() => navigate("/reset-password")}
          >
            I have my code - Reset Password
          </Button>
        )}

        <Box mt={2}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Link to="/register">New here? Sign Up</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/login">Already have an account? Log In</Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Layout>
  );
};

export default ForgotCredentials;
